import React, { useState } from 'react';
import { COLORS, TYPOGRAPHY, SPACING, SHADOWS, RADIUS, TRANSITIONS, GRADIENTS } from '../constants/designTokens';
import { SITE } from '../constants/siteConfig';

const FloatingContactButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    const formData = new FormData(event.target);

    formData.append("access_key", SITE.web3formsKey);
    formData.append("from_name", "Marine Sealink B.V. Website");
    formData.append("subject", "New message from Marine Sealink B.V. floating contact form");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Message sent successfully!");
      event.target.reset();
      setTimeout(() => {
        setResult("");
        setIsModalOpen(false);
      }, 2000);
    } else {
      setResult(data.message);
    }
  };

  return (
    <>
      <style>{`
        .floating-contact-btn {
          position: fixed;
          bottom: 30px;
          right: 30px;
          width: 60px;
          height: 60px;
          background: ${GRADIENTS.teal};
          border-radius: ${RADIUS.full};
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 20px rgba(64, 168, 196, 0.4);
          cursor: pointer;
          z-index: 1000;
          transition: ${TRANSITIONS.all};
          border: none;
        }

        .floating-contact-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 30px rgba(64, 168, 196, 0.6);
        }

        .floating-contact-btn i {
          color: ${COLORS.text.white};
          font-size: 1.5rem;
        }

        .contact-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(8, 32, 50, 0.8);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .contact-modal {
          background: ${COLORS.background.white};
          border-radius: ${RADIUS['2xl']};
          max-width: 500px;
          width: 90%;
          min-width: 300px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: ${SHADOWS['2xl']};
          animation: slideUp 0.3s ease;
          position: relative;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-header {
          background: linear-gradient(135deg, ${COLORS.primary.dark} 0%, #0f2940 100%);
          color: ${COLORS.text.white};
          padding: ${SPACING.xl};
          border-radius: ${RADIUS['2xl']} ${RADIUS['2xl']} 0 0;
          position: relative;
        }

        .modal-header h3 {
          margin: 0;
          font-size: ${TYPOGRAPHY.fontSize.xl};
          font-weight: ${TYPOGRAPHY.fontWeight.bold};
        }

        .modal-header p {
          margin: ${SPACING.xs} 0 0 0;
          opacity: 0.9;
          font-size: ${TYPOGRAPHY.fontSize.sm};
        }

        .modal-close {
          position: absolute;
          top: ${SPACING.lg};
          right: ${SPACING.lg};
          background: rgba(255, 255, 255, 0.2);
          border: none;
          color: ${COLORS.text.white};
          width: 35px;
          height: 35px;
          border-radius: ${RADIUS.full};
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: ${TRANSITIONS.all};
          font-size: 1.2rem;
        }

        .modal-close:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: rotate(90deg);
        }

        .modal-body {
          padding: ${SPACING.xl};
        }

        .modal-form-group {
          margin-bottom: ${SPACING.lg};
        }

        .modal-form-group label {
          display: block;
          color: ${COLORS.primary.dark};
          font-weight: ${TYPOGRAPHY.fontWeight.semibold};
          margin-bottom: ${SPACING.xs};
          font-size: ${TYPOGRAPHY.fontSize.sm};
        }

        .modal-form-control {
          width: 100%;
          padding: ${SPACING.sm} ${SPACING.md};
          border: 2px solid ${COLORS.ui.border};
          border-radius: ${RADIUS.lg};
          font-size: ${TYPOGRAPHY.fontSize.base};
          transition: ${TRANSITIONS.all};
          font-family: inherit;
        }

        .modal-form-control:focus {
          outline: none;
          border-color: ${COLORS.primary.teal};
          box-shadow: 0 0 0 3px rgba(64, 168, 196, 0.1);
        }

        .modal-form-control::placeholder {
          color: ${COLORS.text.light};
        }

        textarea.modal-form-control {
          resize: vertical;
          min-height: 120px;
        }

        .modal-submit-btn {
          width: 100%;
          padding: ${SPACING.md};
          background: ${GRADIENTS.teal};
          color: ${COLORS.text.white};
          border: none;
          border-radius: ${RADIUS.lg};
          font-size: ${TYPOGRAPHY.fontSize.md};
          font-weight: ${TYPOGRAPHY.fontWeight.semibold};
          cursor: pointer;
          transition: ${TRANSITIONS.all};
        }

        .modal-submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(64, 168, 196, 0.4);
        }

        .modal-submit-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .modal-result {
          text-align: center;
          padding: ${SPACING.md};
          margin-top: ${SPACING.md};
          border-radius: ${RADIUS.lg};
          font-weight: ${TYPOGRAPHY.fontWeight.semibold};
        }

        .modal-result.success {
          background: rgba(16, 185, 129, 0.1);
          color: ${COLORS.ui.success};
        }

        .modal-result.error {
          background: rgba(239, 68, 68, 0.1);
          color: ${COLORS.ui.error};
        }

        @media (max-width: 768px) {
          .floating-contact-btn {
            bottom: 20px;
            right: 20px;
            width: 56px;
            height: 56px;
          }

          .modal-header h3 {
            font-size: ${TYPOGRAPHY.fontSize.lg};
          }

          .modal-body {
            padding: ${SPACING.lg};
          }
        }

        @media (max-width: 576px) {
          .contact-modal {
            width: 95%;
            min-width: 280px;
          }

          .modal-header {
            padding: ${SPACING.lg};
          }

          .modal-header h3 {
            font-size: ${TYPOGRAPHY.fontSize.lg};
          }

          .modal-body {
            padding: ${SPACING.md};
          }

          .modal-form-group {
            margin-bottom: ${SPACING.md};
          }
        }

        @media (max-width: 480px) {
          .floating-contact-btn {
            width: 52px;
            height: 52px;
          }

          .floating-contact-btn i {
            font-size: 1.3rem;
          }

          .contact-modal {
            min-width: 260px;
          }

          .modal-header h3 {
            font-size: ${TYPOGRAPHY.fontSize.md};
          }

          .modal-header p {
            font-size: ${TYPOGRAPHY.fontSize.xs};
          }
        }

        @media (max-width: 375px) {
          .floating-contact-btn {
            bottom: 15px;
            right: 15px;
            width: 50px;
            height: 50px;
          }
        }
      `}</style>

      {/* Floating Contact Button */}
      <button
        className="floating-contact-btn"
        onClick={() => setIsModalOpen(true)}
        aria-label="Open contact form"
      >
        <i className="fas fa-envelope"></i>
      </button>

      {/* Contact Modal */}
      {isModalOpen && (
        <div className="contact-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <button
                className="modal-close"
                onClick={() => setIsModalOpen(false)}
                aria-label="Close modal"
              >
                ×
              </button>
              <h3>Get In Touch</h3>
              <p>Send us a message and we'll get back to you soon</p>
            </div>

            <div className="modal-body">
              <form onSubmit={onSubmit}>
                <div className="modal-form-group">
                  <label htmlFor="modal-name">Your Name</label>
                  <input
                    type="text"
                    id="modal-name"
                    name="name"
                    className="modal-form-control"
                    placeholder="John Doe"
                    required
                  />
                </div>

                <div className="modal-form-group">
                  <label htmlFor="modal-email">Email Address</label>
                  <input
                    type="email"
                    id="modal-email"
                    name="email"
                    className="modal-form-control"
                    placeholder="john@example.com"
                    required
                  />
                </div>

                <div className="modal-form-group">
                  <label htmlFor="modal-message">Message</label>
                  <textarea
                    id="modal-message"
                    name="message"
                    className="modal-form-control"
                    placeholder="How can we help you?"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="modal-submit-btn"
                  disabled={result === "Sending..."}
                >
                  {result === "Sending..." ? "Sending..." : "Send Message"}
                </button>

                {result && result !== "Sending..." && (
                  <div className={`modal-result ${result.includes("success") ? "success" : "error"}`}>
                    {result}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingContactButton;
